import { render, staticRenderFns } from "./WarehouseTable.vue?vue&type=template&id=36d7e416"
import script from "./WarehouseTable.vue?vue&type=script&lang=js"
export * from "./WarehouseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports